import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
    nationalCode: Yup.string()
        .matches(/^\d{10}$/, 'کد ملی باید دقیقا ۱۰ رقم باشد')
        .max(10, 'کد ملی نمی‌تواند بیشتر از ۱۰ رقم باشد')
        .required('کد ملی الزامی است'),
    phoneNumber: Yup.string()
        .matches(
            /^09\d{9}$/,
            'شماره تلفن باید با 09 شروع شده و دقیقا ۱۱ رقم باشد'
        )
        .max(11, 'شماره تلفن نمی‌تواند بیشتر از ۱۱ رقم باشد')
        .required('شماره تلفن الزامی است'),
    serialCode: Yup.string()
        .matches(/^\d{10}$/, 'سریال کد باید دقیقا ۱۰ رقم باشد')
        .max(10, 'سریال کد نمی‌تواند بیشتر از ۱۰ رقم باشد')
        .required('سریال کد الزامی است'),
    nationalCardPhoto: Yup.mixed().required('بارگذاری عکس کارت ملی الزامی است'),
})
